import { tradeRoutesResource } from "@legacy-megarax/crm-contracts";
import { useResourceProviderV2 } from "@legacy-megarax/react-client";
import { commonErrorsMap, useSnackbarErrorHandler } from "@legacy-megarax/ui-components";
import { useQuery } from "react-query";

export const useFixedRoutes = (searchText: string, userId: number) => {
  const provider = useResourceProviderV2(tradeRoutesResource);

  const errorHandler = useSnackbarErrorHandler({
    ...commonErrorsMap,
  });

  const { data } = useQuery(["routeOptions", searchText], () =>
    provider
      .listNamed({
        salespersonId: userId,
        searchText,
      })
      .mapError(errorHandler)
      .then((r) => r.assertOk().value.items),
  );

  return data;
};
